module.exports = __webpack_public_path__ + "img/1F1EC-1F1F5.aa921be4.svg";